const permissions = {
  apiKeysProduct: 'AK001',
  apiKeysConsumptionReport: 'AK002',
  apiKeysCatalog: 'AK003'
};

export default permissions;
